import Project from '../project/Project';
import sennheiserImg from '../../images/sennheiser.png';
import smartopsImg from '../../images/smartops.png';
import './Projects.css';

// https://i.ibb.co/Th13zdV/Copa-America.png
// https://i.ibb.co/jwbqz8Q/Panda-Shop.png
// https://i.ibb.co/2PKW814/Sennheiser.png

const projectsData = [
  {
    "id": 1,
    "img": sennheiserImg,
    "name": "Sennheiser",
    "website": "https://sennheiser.vercel.app/",
    "codeLink": "https://github.com/Yeasin307/Sennheiser_Ecommerce",
    "description": [
      "Build a fully responsive Modern Full Stack ECommerce application with Payments functionality (Stripe). With Modern design, animations, all advanced cart functionalities and most importantly the complete integration with Stripe so that you can cover real payments. The ability to add and edit products on the go using a CMS (Sanity.io)."
    ],
    "Technology": [
      "Next js",
      "Sanity.io",
      "Stripe"
    ]
  },
  {
    "id": 2,
    "img": smartopsImg,
    "name": "SmartOPS",
    "website": "https://smartone-smartops.netlify.app/",
    "codeLink": "https://github.com/Yeasin307/SmartOPS",
    "description": [
      "Refactored an existing project management tool with the new backend API for an award-winning Canadian technology start-up (SmartONE Solutions Inc.). Integrated MS Entra ID authentication using OAuth 2.0 and new features and functionalities."
    ],
    "Technology": [
      "React js",
      "React Router",
      "Bootstrap",
      "MS Entra ID",
      "Material-UI",
      "Quill Text Editor"
    ]
  }
  // {
  //   "id": 2,
  //   "img": "https://i.ibb.co/ByG16Nm/Apache-Bike.png",
  //   "name": "Apache Bike House",
  //   "website": "https://apache-bike-house.web.app/",
  //   "frontendCode": "https://github.com/Yeasin307/Apache-Bike-House-Client-Side",
  //   "backendCode": "https://github.com/Yeasin307/Apache-Bike-House-Server-Side",
  //   "description": [
  //     "Build a Full Stack ECommerce application for selling Bike with Stripe payments system.The dashboard has different functionality for Users and Admin. Users can order products, cancel orders, pay and review products. Admin can manage all orders, manage products and manage admin panel. Using JWT for secure API. Using image Upload as Base64 image. For Admin use (Email: admin@admin.com and Password: 123456)."
  //   ],
  //   "Technology": [
  //     "React js",
  //     "React router",
  //     "Material-UI",
  //     "Firebase",
  //     "Node js",
  //     "Express js",
  //     "MongoDB",
  //     "JWT",
  //     "Stripe"
  //   ]
  // },
  // {
  //   "id": 3,
  //   "img": "https://i.ibb.co/3CqrFRq/Prime-Hospital.png",
  //   "name": "Prime Care Hospital",
  //   "website": "https://prime-care-diagnostic-center.web.app/",
  //   "frontendCode": "https://github.com/Yeasin307/Prime-Care-Hospital",
  //   "description": [
  //     "Build a Frontend application with Firebase authentication system. User can login with Email, Password base login system, and Google login system. For Details and Contact us section user must be login"
  //   ],
  //   "Technology": [
  //     "React js",
  //     "React router",
  //     "React BootStrap",
  //     "BootStrap",
  //     "Firebase",
  //     "Fontawesome"
  //   ]
  // },
  // {
  //   "id": 4,
  //   "img": "https://i.ibb.co/DDwGT0x/BD-Coding.png",
  //   "name": "BD Coding Academy ",
  //   "website": "https://bd-coding-academy.netlify.app/",
  //   "frontendCode": "https://github.com/Yeasin307/BD-Coding-Academy",
  //   "description": ["Build a simple React application with React Router. Fully responsive, Deploy with Netlify and use Fontawesome Icons."
  //   ],
  //   "Technology": [
  //     "React js",
  //     "React router",
  //     "React BootStrap",
  //     "BootStrap",
  //     "Fontawesome"
  //   ]
  // }
]

const Projects = () => {
  return (
    <div id="projects">
      <h2 className="pb-5 mb-5 container projects-title">My Projects</h2>
      {projectsData.map((project) =>
        <Project
          key={project.id}
          project={project}
        />
      )}
    </div>
  );
};

export default Projects;